import { STICKY_HEADER_HEIGHT } from 'shared/constants/elements';
import { isBrowserWindowFullScrolled } from 'shared/utils/dom/isBrowserWindowFullScrolled';

import { TabDataModel } from './TabDataModel';

export class TabDataCollectionModel {
  public list = Array.of<TabDataModel>();

  public constructor(clauses: Array<HTMLElement>) {
    this.setListByClauses = clauses;
  }

  public get length(): number {
    return this.list.length;
  }

  public get isEmptyList(): boolean {
    return this.length === 0;
  }

  public set setListByClauses(clauses: Array<HTMLElement>) {
    this.list = clauses
      .reduce((accumulator, tabElement) => {
        const [anchor, title] = (tabElement.dataset.navTab || '/').split('/');

        if (title && anchor) {
          accumulator.push(new TabDataModel(title, anchor, tabElement.offsetTop));
        }

        return accumulator;
      }, Array.of<TabDataModel>())
      .sort((a, b) => a.point - b.point);
  }

  public getActiveTab(): TabDataModel | null {
    if (this.isEmptyList) {
      return null;
    }

    if (isBrowserWindowFullScrolled()) {
      return this.lastTab;
    }

    for (let i = this.length - 1; i >= 0; i -= 1) {
      const tab = this.list[i];

      const anchorDomNode = document.getElementById(tab.value);

      if (anchorDomNode) {
        const isInViewPort = anchorDomNode.getBoundingClientRect().top <= STICKY_HEADER_HEIGHT;

        if (isInViewPort) {
          return tab;
        }
      }
    }

    return this.firstTab;
  }

  private get firstTab(): TabDataModel {
    return this.list[0];
  }

  private get lastTab(): TabDataModel {
    return this.list[this.length - 1];
  }
}
